import { observer } from 'mobx-react';
import { Component } from 'react';
import OrderDelivery from '../OrderDelivery/OrderDelivery';
import OrderDetails from '../OrderDetails/OrderDetails';
import OrderDineIn from '../OrderDineIn/OrderDineIn';
import { OrderMain } from '../OrderMain/OrderMain';
import OrderNavigation from '../OrderNavigation/OrderNavigation';
import OrderPickup from '../OrderPickup/OrderPickup';
import { withOrderStore } from '../../context';
import { ORDER_SECTIONS } from 'src/constants/order';
import { OrderStore } from '~/mobx/orderStore';

// @ts-ignore
@withOrderStore
@observer
export default class OrderSections extends Component<{ orderStore?: OrderStore }, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  private get section() {
    let section = null;
    switch (this.orderStore.section) {
      case ORDER_SECTIONS.ORDER:
        section = <OrderMain key={this.orderStore.order?.id} />;
        break;
      case ORDER_SECTIONS.DELIVERY:
        section = <OrderDelivery key={this.orderStore.order?.id} />;
        break;
      case ORDER_SECTIONS.PICKUP:
        section = <OrderPickup key={this.orderStore.order?.id} />;
        break;
      case ORDER_SECTIONS.DETAILS:
        section = <OrderDetails key={this.orderStore.order?.id} />;
        break;
      case ORDER_SECTIONS.DINE_IN:
        section = <OrderDineIn key={this.orderStore.order?.id} />;
        break;

      default:
        section = null;
        break;
    }
    return section;
  }

  render() {
    return (
      <>
        <OrderNavigation />
        {this.section}
      </>
    );
  }
}
